module.exports = __webpack_public_path__ + "img/02.31a48f93.png";